export const SETTINGS_STORAGE_KEY = "settings";
